import { Pipe, PipeTransform } from '@angular/core';
import { FileService } from '../services/file/file.service';

@Pipe({ name: 'imageURL',pure:false })
export class ImageURLPipe implements PipeTransform {
  constructor(private fileService:FileService){

  }
  transform(url: string,size:Number,type?:string) {
    return this.fileService.getPhotoUrl(url,size,type);
  }
}